import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'nextFields',
    'pleaseChoose',
    'clientDesc',
    'creatorDesc',
    'clientType',
    'creatorType',
    'creatorShow',
  ]

  chooseType() {
    this.pleaseChooseTarget.classList.add('d-none')
    this.nextFieldsTarget.classList.remove('d-none')
    this.setVisibilities()
    console.log('this.creatorTypeTarget.checked: ' + this.creatorTypeTarget.checked)
    console.log('this.clientTypeTarget.checked: ' + this.clientTypeTarget.checked)
  }

  setVisibilities() {
    const clientDescList = this.clientDescTarget.classList
    const creatorDescList = this.creatorDescTarget.classList
    const creatorShowList = this.creatorShowTarget.classList
    if (this.creatorTypeTarget.checked) {
      clientDescList.add('d-none')
      creatorDescList.remove('d-none')
      creatorShowList.remove('d-none')
    } else if (this.clientTypeTarget.checked) {
      clientDescList.remove('d-none')
      creatorDescList.add('d-none')
      creatorShowList.add('d-none')
    }
  }

}
